<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="DETALLES GENERALES" />

      <b-row align-h="center" class="mt-5">
        <b-col cols="10" lg="6">
          <ValidationObserver ref="mainObserver" v-slot="{ invalid }">
            <b-row class="mb-4">
              <ValidationProvider rules="required" name="Nombre" style="width: 100%" v-slot="{ valid, errors }">
                <Label label="Nombre" :blank="submitalForm.title" show-reset @reset="submitalForm.title = null" />
                <b-input-group size="lg">
                  <b-input
                    v-model="submitalForm.title"
                    type="text"
                    :state="errors[0] ? false : (valid ? true : false)"
                    trim
                    @blur="updateSubmital"
                  />
                </b-input-group>
              </ValidationProvider>
            </b-row>
            <b-row class="mb-4">
              <ValidationProvider :rules="{ required: true, numeric: true, min_value: 1 }" name="cantidad" style="width: 100%" v-slot="{ valid, errors }">
                <Label label="Cantidad de unidades idénticas" :blank="submitalForm.quantity" show-reset @reset="submitalForm.quantity = null" />
                <b-input-group size="lg">
                  <b-input
                    v-model.number="submitalForm.quantity"
                    type="number"
                    :state="errors[0] ? false : (valid ? true : false)"
                    min="1"
                    max="100"
                    step="1"
                    @blur="updateSubmital"
                  />
                </b-input-group>
              </ValidationProvider>
            </b-row>

            <b-row class="mb-4">
              <ValidationProvider rules="required" name="Tipo de Proyecto" style="width: 100%" v-slot="{ valid, errors }">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Tipo de Proyecto" :blank="form.project_type" show-reset @reset="form.project_type = null" />
                  </template>
                  <b-select
                    v-model="form.project_type"
                    :state="errors[0] ? false : (valid ? true : null)"
                    :options="projectTypeOptions"
                  >
                    <template #first>
                      <b-select-option v-show="!form.project_type" :value="null">
                        -- seleccionar --
                      </b-select-option>
                    </template>
                  </b-select>
                </b-form-group>
              </ValidationProvider>
            </b-row>

            <b-row class="mb-4">
              <ValidationProvider rules="required" name="Tipo de Sistemas" style="width: 100%" v-slot="{ valid, errors }">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Tipo de Sistemas" :blank="form.system_type" show-reset @reset="form.system_type = null" />
                  </template>
                  <b-select
                    v-model="form.system_type"
                    :state="errors[0] ? false : (valid ? true : null)"
                    :options="systemTypeOptions"
                  >
                    <template #first>
                      <b-select-option v-show="!form.system_type" :value="null">
                        -- seleccionar --
                      </b-select-option>
                    </template>
                  </b-select>
                </b-form-group>
              </ValidationProvider>
            </b-row>

            <b-row class="mb-4">
              <ValidationProvider rules="required" name="Tipo de acceso a controlar" style="width: 100%" v-slot="{ valid, errors }">
                <b-form-group class="w-100">
                  <template #label>
                    <Label label="Tipo de acceso a controlar" :blank="accessControlTypeForm.category" show-reset @reset="onChangeAccessControlCategory(null)" />
                  </template>
                  <b-select
                    v-model="accessControlTypeForm.category"
                    :state="errors[0] ? false : (valid ? true : null)"
                    :options="accessToControlOptions"
                    @change="onChangeAccessControlCategory"
                  >
                    <template #first>
                      <b-select-option :value="null">
                        -- seleccionar --
                      </b-select-option>
                    </template>
                  </b-select>
                </b-form-group>
              </ValidationProvider>
            </b-row>

            <b-row class="mb-4">
              <b-form-group class="w-100">
                <template #label>
                  <Label label="Paso a controlar" :blank="form.access_control_type_id" show-reset @reset="onChangeControlAccessName(null)">
                    <template #text>
                      <span v-if="!accessControlTypeForm.category" class="text-info">
                        <font-awesome-icon :icon="['far', 'info-circle']" fixed-width />
                        <span class="ml-1">Debe seleccionar tipo de acceso a controlar</span>
                      </span>
                    </template>
                  </Label>
                </template>
                <b-select
                  v-model="form.access_control_type_id"
                  :options="accessControlTypeOptions"
                  :disabled="accessControlTypeForm.category == null || processing"
                  @change="onChangeControlAccessName"
                >
                  <template #first>
                    <b-select-option :value="null">
                      -- seleccionar --
                    </b-select-option>
                  </template>
                </b-select>
              </b-form-group>
            </b-row>

            <b-row class="mb-4">
              <b-col class="px-0">
                <RelatedSubmitalSelector
                  :project="submital.project"
                  currentConfigurableType="Submital"
                  :currentConfigurableId="submital.id"
                  :relatedSubmital="submital.related_configurable || {}"
                  @relationship-changed="onRelationshipChanged"
                />
              </b-col>
            </b-row>

            <b-row
              v-for="item in tableQuestions"
              :key="item.model"
              class="align-items-center pb-2"
            >
              <b-col cols="12" lg="9" class="px-0">
                <Label
                  :label="item.label"
                  :show-reset="form[item.model] == true || form[item.model] == false"
                  :blank="form[item.model] === null ? null : 'true'"
                  @reset="form[item.model] = null"
                />
              </b-col>

              <b-col cols="12" lg="3" class="text-lg-right mt-2 mt-lg-0 px-0">
                <b-form-group>
                  <b-radio-group size="lg" v-model="form[item.model]" class="ml-4">
                    <b-radio :value="true">Si</b-radio>
                    <b-radio :value="false">No</b-radio>
                  </b-radio-group>
                </b-form-group>
              </b-col>
            </b-row>

            <StepNotes
              label="Notas, Indicar detalles para viabilidad de integraciones citadas"
              :value="form.general_notes"
              @update-form="updateStepNotes"
            />

            <span class="d-none">{{ invalid }}</span>
          </ValidationObserver>
        </b-col>
      </b-row>
    </b-container>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
  projectTypeOptions,
  systemTypeOptions,
  accessToControlOptions
} from '../../../../sharedOptions/controlesAccesoModule'

import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import Label from '../Label'
import StepNotes from '../StepNotes'
import RelatedSubmitalSelector from '../RelatedSubmitalSelector'

export default {
  name: 'General',
  components: {
    ConfiguratorStepTitle,
    ValidationObserver,
    ValidationProvider,
    Label,
    StepNotes,
    RelatedSubmitalSelector
  },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      processing: false,
      submitalForm: {
        title: '',
        quantity: 1
      },
      tableQuestions: [
        {
          label: "Registro de entradas y salidas",
          model: "requires_entry_exit_logging"
        },
        {
          label: "Solicitud de integración con video vigilancia",
          model: "requires_video_integration"
        },
        {
          label: "Integración con Alarma de incendio",
          model: "requires_fire_alarm"
        },
        {
          label: "Versiones de clientes, usuarios Remotos",
          model: "requires_remote_clients"
        },
        {
          label: "Se requiere base de datos Específica (SQL, Access, Maria DB, Otro)",
          model: "requires_specific_database"
        },
        {
          label: "Enviar los requerimientos de PC según el software",
          model: "requires_pc_requirements"
        },
        {
          label: "Credenciales Virtuales",
          model: "requires_virtual_credentials"
        }
      ],
      form: {
        project_type: '',
        system_type: '',
        access_control_type_id: null,
        requires_entry_exit_logging: null,
        requires_video_integration: null,
        requires_fire_alarm: null,
        requires_remote_clients: null,
        requires_specific_database: null,
        requires_pc_requirements: null,
        requires_virtual_credentials: null,
        general_notes: '',
        motor_id: null
      },
      accessControlTypeForm: {
        category: null
      },
      accessControlTypes: [],
      projectTypeOptions: projectTypeOptions,
      systemTypeOptions: systemTypeOptions,
      accessToControlOptions: accessToControlOptions,
    }
  },
  mounted () {
    if (this.submital) {
      this.submitalForm.title = this.submital.title
      this.submitalForm.quantity = this.submital.quantity
    }

    const accessControl = this.accessControl
    if (this.accessControl) {
      this.form.project_type = accessControl.project_type
      this.form.system_type = accessControl.system_type
      this.form.requires_entry_exit_logging = accessControl.requires_entry_exit_logging
      this.form.requires_fire_alarm = accessControl.requires_fire_alarm
      this.form.requires_video_integration = accessControl.requires_video_integration
      this.form.requires_remote_clients = accessControl.requires_remote_clients
      this.form.requires_specific_database = accessControl.requires_specific_database
      this.form.requires_pc_requirements = accessControl.requires_pc_requirements
      this.form.requires_virtual_credentials = accessControl.requires_virtual_credentials
      this.form.general_notes = accessControl.general_notes
      this.form.motor_id = accessControl.motor_id
      this.form.access_control_type_id = accessControl.access_control_type_id
      const accessControlType = accessControl.access_control_type
      if (accessControl.access_control_type_id && accessControlType) {
        this.accessControlTypeForm.category = accessControlType.category
        this.getAccessControlTypeOptions(accessControlType.category, true)
        this.form.access_control_type_id = accessControlType.id
      }
    }
  },
  computed: {
    ...mapState({
      accessControl: state => state.configurator.configurable,
      submital: state => state.configurator.submital
    }),
    ...mapGetters(['configuratorStepNumber']),
    accessControlTypeOptions () {
      return this.accessControlTypes.map(type => ({ text: type.name, value: type.id }))
    }
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable({
        controlacceso: this.form
      })

      return result
    },
    updateSubmital () {
      this.submitalForm.quantity = this.submitalForm.quantity > 1 ? this.submitalForm.quantity : 1

      this.$emit('update-submital', this.submitalForm)
    },
    formHasChanged () {
      // TODO: implement this
      return true
      // return Object.entries(this.form).some(([key, value]) => value !== this.accessControl[key])
    },
    updateStepNotes (notes) {
      this.form.general_notes = notes
    },
    // class methods
    getAccessControlTypeOptions (category, onMount = false) {
      if (this.processing || !category) { return }
      this.processing = true
      this.$http.get('/api/production/submital/controles_acceso/access_control_types', {
          params: {
            category: category
          }
      })
        .then((res) => {
          // console.log(res.data)
          this.accessControlTypes = res.data
          if (!onMount) {
            this.form.access_control_type_id = null
          }
        })
        .catch(e => console.log(e))
        .finally(() => this.processing = false)
    },
    onChangeAccessControlCategory (category) {
      if (!category) {
        this.accessControlTypeForm.category = null
        this.form.access_control_type_id = null
        return
      }
      this.accessControlTypeForm.category = category

      this.getAccessControlTypeOptions(category)
    },
    onChangeControlAccessName (id) {
      const typeSelected = this.accessControlTypes.find(type => type.id === id)
      if (!id || !typeSelected) {
        this.form.access_control_type_id = null
        // TODO: reset accessControl in store
        return
      }
      this.form.access_control_type_id = typeSelected.id
      this.form.motor_id = null
    },
    onRelationshipChanged (relatedConfigurable) {
      this.$store.commit('setSubmital', {
        id: this.submital.id,
        related_configurable: relatedConfigurable
      })
    }
  }
}
</script>
